let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电订单号',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '充电桩设备接口编码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '开始充电时间',
        props: 'orderNo',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '结束充电时间',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '累计充电量',
        props: 'sourceName',
        minWidth: 200,
    },
    {
        label: '总电费',
        props: 'chargeStepName',
        minWidth: 200,
    },
    {
        label: '总服务费',
        props: 'orderPropertyName',
        minWidth: 120,
    },
    {
        label: '累计总金额',
        props: 'chargeDay',
        minWidth: 200,
    },
    {
        label: '充电结束原因',
        props: 'chargSeconds',
        sortable:true,
        minWidth: 180,
        // formatter: function formatter(row, column, cellValue, index) {
        //     //做判断
        //     if (row.chargSeconds) {
        //         return Math.floor(row.chargSeconds / 60) + '分' + Math.floor(row.chargSeconds % 60) + '秒'
        //     }
        // }
    },
    {
        label: '时段数',
        props: '',
        minWidth: 160,
    },
];

// 详情列表项
pageConfig.custDetailColumns = [
    {
        label: '时段',
        props: 'rcsCode',
        minWidth: 140,
    },
    {
        label: '开始充电时间',
        props: 'createdWhen',
        minWidth: 160,
        tooltip:true,
    },
    {
        label: '结束充电时间',
        props: 'pileStatusName',
        minWidth: 160,
    },
    {
        label: '本时段充电时长',
        props: 'remark',
        minWidth: 140,
    },
    {
        label: '本时段充电量',
        props: 'remark',
        minWidth: 140,
    },
    {
        label: '本时段电费',
        props: 'remark',
        minWidth: 140,
    },
    {
        label: '本时段服务费',
        props: 'remark',
        minWidth: 140,
    },
    {
        label: '本时段金额',
        props: 'remark',
        minWidth: 140,
    },
];

// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单对账'
    }
];

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单对账',
    },
    {
        type: 'title',
        name: '订单对账详情'
    }
];

// 列表-表格属性
pageConfig.tableConfigList = {
    showSelection: true,
    showIndex: true,
};

// 详情-列表属性
pageConfig.tableConfigDetail = {
    showSelection: false,
    showIndex: true,
}

// 列表-分页参数
pageConfig.paginationList = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 详情-分页参数
pageConfig.paginationDetail = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [2,3,4,5,10, 20, 50, 100],
}

export default pageConfig;
